import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelContainer from "../components/PanelContainer";

class SecurePage extends Component {

  render() {
    let {viewContext, viewTitle} = this.props;

    return (
      <div className="SecurePage">
        <AppSidebar />
        <PageHeader context={viewContext} title={viewTitle} />
        <div className="PageContainer">
          {this.props.children}
        </div>
        <PanelContainer
          context={viewContext}
          selection={this.props.selection}
          >
        </PanelContainer>
      </div>
    );
  }
}

export default SecurePage;
